import { Card, ToggleButtonGroup } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

import Context from "../../context";
import ToggleItem from "./ToggleItem";

// ----------------------------------------------------------------------

export const DemoToggle = () => {
	const { actions, state } = useContext(Context);
	const isMobile = useResponsive("down", "sm");
	const { translate } = useLocales();

	return (
		<Card>
			<ToggleButtonGroup
				aria-label='Platform'
				color='primary'
				exclusive
				fullWidth={isMobile}
				onChange={(_e, value) => actions.setShowTable(value === "table")}
				size='small'
				value={state.showTable ? "table" : "json"}
			>
				<ToggleItem
					icon='material-symbols:table'
					title={translate("result_demo.table")}
					value={"table"}
				/>
				<ToggleItem icon='codicon:json' title='JSON' value={"json"} />
			</ToggleButtonGroup>
		</Card>
	);
};

export default DemoToggle;
